// src/index.ts
var MODELER_API_VERSION = "1.6.0";
function apiVersionsCompatible(a, b) {
  const [aMajor = "", aMinor = ""] = a.split(".");
  const [bMajor = "", bMinor = ""] = b.split(".");
  if (aMajor !== bMajor) return false;
  return aMajor !== "0" || aMinor === bMinor;
}

export {
  MODELER_API_VERSION,
  apiVersionsCompatible
};
//# sourceMappingURL=chunk-ENLUVZLZ.js.map